export const getRoles = state => !!state.auth.auth && state.auth.auth.roles;
